import { api } from "./api";

export const uploadDrugLicenceApi = (params) => {
  return api.post(
    "/distributor/onbording/upload-drug-licence-certificate",
    params,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const uploadGSTCertificateApi = (params) => {
  return api.post("/distributor/onbording/upload-gst-certificate", params, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const registerDistributorDetailsApi = (params) => {
  return api.post(
    "/distributor/onbording/register-distribution-details",
    JSON.stringify(params)
  );
};

export const registerDistributorContactDetailApi = (params) => {
  return api.post(
    "/distributor/onbording/distributor-contact-details",
    JSON.stringify(params)
  );
};
